import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Checkbox, FormHelperText, Grid } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import AppDialog from "../../../../components/Common/AppDialog";
import Breadcrumb from "../../../../components/Common/Breadcrumb";
import Label from "../../../../components/Common/Label";
import LoadingDialog from "../../../../components/Common/LoadingDialog";
import Notification from "../../../../components/Common/Notification";
import SearchBar from "../../../../components/Common/Searchbar";
import Table from "../../../../components/Common/Table";
import TablePageControl from "../../../../components/Common/TablePageControl";
import CustomButton from "../../../../components/Form/CustomButton";
import CustomIconButton from "../../../../components/Form/CustomIconButton";
import CustomSelect2 from "../../../../components/Form/CustomSelect2";
import CustomTextField from "../../../../components/Form/CustomTextField";
import RadioButtonGroup from "../../../../components/Form/RadioButtonGroup";
import Helpers from "../../../../helpers/helpers";
import { bulkDeleteServiceType, createServiceType, deleteServiceType, exportServiceType, getGeneral, getServiceTypeListing, resetServiceTypeAttachmentState, resetServiceTypeState, updateServiceType } from "../../../../store/actions";
import "../../setting.css";
import DeleteModal from "../../../../components/Common/DeleteModal";


const ProductServiceSetting = ({ title, serviceTypeListing, exportServiceTypeDocument, addServiceType, editServiceType, formError, userPermission, bulkDeleteServiceTypeArr, delServiceTypeArry }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(resetServiceTypeAttachmentState());
    }, [])

    useEffect(() => {
        if (delServiceTypeArry?.code === "success") {
            setDeleteOpen(false);
            setNotification({
                open: true,
                msg: "Delete Successfully",
                type: "success",
            })
            dispatch(resetServiceTypeState())
            dispatch(getGeneral());
            setSelectedRow([]);
            initData()
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [delServiceTypeArry]);

    useEffect(() => {
        if (bulkDeleteServiceTypeArr?.code === "success") {
            setIsLoading(false);
            setDeleteOpen(false);
            setNotification({
                open: true,
                msg: "Delete Successfully",
                type: "success",
            })
            dispatch(resetServiceTypeState())
            dispatch(getGeneral());
            initData()
        } else if (bulkDeleteServiceTypeArr?.code === "invalid_service") {
            setIsLoading(false);
            setDeleteOpen(false);
            setNotification({
                open: true,
                msg: "Invalid service",
                type: "error",
            })
            dispatch(resetServiceTypeState())
            initData()
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bulkDeleteServiceTypeArr]);

    const [loading, setIsLoading] = useState(false);
    const [filterStatus, setFilterStatus] = useState('all');
    const [values, setFormValues] = useState({ category: '' });
    const [selectedRow, setSelectedRow] = useState([]);
    const [addModalOpen, setAddModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [imagePreview, setImagePreview] = useState('');
    const [imagePayload, setImagePayload] = useState(null);
    const [removeImage, setRemoveImage] = useState(false);
    const addImageInputRef = useRef(null);
    const editImageInputRef = useRef(null);
    const [checkedAll, setCheckedAll] = useState(false);
    const [page, setPage] = useState("1");
    const [length, setLength] = useState("50");
    const [keyword, setSearch] = useState("");
    const [sort, setSorted] = useState("asc");
    const [sort_by, setSortBy] = useState("sort_order");
    const [error, setError] = useState();
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    const data = [
        { value: "1", label: "Active" },
        { value: "0", label: "Inactive" },
    ]
    const [creatable, setCreatable] = useState(false);
    const [editable, setEditable] = useState(false);
    const [deletable, setDeletable] = useState(false);
    const [exportable, setExportable] = useState(false);
    const [viewable, setViewable] = useState(false);
    const searchRef = useRef(keyword);

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("create-setting") && setCreatable(true);
            userPermission?.includes("edit-setting") && setEditable(true);
            userPermission?.includes("delete-setting") && setDeletable(true);
            userPermission?.includes("export-setting") && setExportable(true);
            userPermission?.includes("view-setting") && setViewable(true);
            !userPermission?.includes("view-setting") && navigate('/not-authorized');
        }
    }, [userPermission])

    useEffect(() => {
        searchRef.current = keyword;
    }, [keyword])
console.log("fdsffsd", selectedRow);
    const header = [
        {
            Header: "#",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <Checkbox
                            checked={checkedAll ? checkedAll : selectedRow?.length > 0 ? selectedRow.includes(cellProps.id) : false}
                            sx={{
                                color: '#D0D0D0',
                                '&.Mui-checked': {
                                    color: "var(--bs-theme-color)",
                                },
                                paddingBlock: 0
                            }}
                            value={cellProps.id}
                            onChange={(event) => handleCheckboxChange(event.target.value, cellProps)} />
                    </React.Fragment>
                )
            },
        },
        {
            Header: "Service Type",
            columnID: "name",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <div className="d-flex align-items-center" style={{ paddingRight: "5px" }}>
                            {(cellProps?.service_descriptions?.length > 0 && cellProps?.service_descriptions[0].name) || '-'}
                        </div>
                    </React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Artwork",
            columnID: "image",
            accessor: (cellProps) => {
                const imageUrl = cellProps?.service_descriptions?.[0]?.image || cellProps?.image;
                return (
                    <React.Fragment>
                        {imageUrl ? (
                            <img
                                src={imageUrl}
                                alt=""
                                style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 6, border: '1px solid #EDEDED' }}
                            />
                        ) : (
                            <span style={{ color: '#999', fontSize: 12 }}>No image</span>
                        )}
                    </React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Status",
            columnID: "status",
            accessor: (cellProps) => {
                return (<React.Fragment><Label.StatusLabel label={cellProps?.status === 1 ? 'active' : 'Inactive'} /></React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Sort Order",
            columnID: "sort_order",
            accessor: (cellProps) => {
                return (<React.Fragment>{cellProps?.sort_order}</React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Action",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        {viewable && <Link to={`/settings-view-product-services/` + (cellProps.id)}>
                            <CustomIconButton
                                iconName={'ri-eye-line'}
                                onClick={() => ''}
                            />
                        </Link>}
                        {editable && <CustomIconButton
                            iconName={'ri-pencil-line'}
                            onClick={() => {
                                const existingImage = cellProps?.service_descriptions?.[0]?.image || cellProps?.image || '';
                                setSelectedRow(cellProps);
                                setImagePreview(existingImage);
                                setImagePayload(null);
                                setRemoveImage(false);
                                setEditModalOpen(true);
                            }}
                        />}
                        {deletable && <CustomIconButton
                            iconName={'ri-delete-bin-line'}
                            onClick={() => { setSelectedRow(cellProps); setDeleteOpen(true) }}
                            backgroundColor={'#44d62c'}
                            color={'white'}
                            borderStyle={"1px solid #44d62c"}
                        />}
                    </React.Fragment>
                )
            },
            minWidth: 120,
            position: 'sticky',
            disableFilters: true,
            filterable: false,
        }
    ]

    useEffect(() => {
        initData();
    }, [sort, sort_by, page, length, filterStatus, sort_by])

    useEffect(() => {
        if (addServiceType?.code === 'success') {
            setAddModalOpen(false);
            resetImageState();
            setNotification({
                open: true,
                msg: 'Service type added successfully',
                type: 'success'
            })
            dispatch(resetServiceTypeState());
            dispatch(getGeneral());
            initData();
        }
        setFormValues("")
        setIsLoading(false);
    }, [addServiceType])

    useEffect(() => {
        if (editServiceType?.code === 'success') {
            setEditModalOpen(false);
            resetImageState();
            setNotification({
                open: true,
                msg: 'Service edited successfully',
                type: 'success'
            })
            dispatch(resetServiceTypeState());
            dispatch(getGeneral());
            initData();
            setFormValues("")
        }
        setIsLoading(false);
    }, [editServiceType])

    useEffect(() => {
        if (exportServiceTypeDocument?.code === 'success' && exportServiceTypeDocument?.excel_base64) {
            Helpers.handleDownloadExcelFile(exportServiceTypeDocument.excel_base64, 'service_type_listing');
            dispatch(resetServiceTypeAttachmentState());
        }
        setIsLoading(false);
    }, [exportServiceTypeDocument])


    const initData = () => {
        let payload = {
            paginate: page,
            sort_order: sort,
            sort: sort_by,
            size: length,
            search: searchRef.current,
            filterStatus: filterStatus === 'all' ? '' : filterStatus
        }
        dispatch(getServiceTypeListing(payload));
    }

    useEffect(() => {
        if (formError?.length > 0) {
            setError(formError[0]);
        } else {
            setError();
        }
        setIsLoading(false);
    }, [formError])

    const resetImageState = () => {
        setImagePreview('');
        setImagePayload(null);
        setRemoveImage(false);
        if (addImageInputRef.current) addImageInputRef.current.value = '';
        if (editImageInputRef.current) editImageInputRef.current.value = '';
    };

    const handleChooseImage = async (file, isEdit = false) => {
        if (!file) return;

        const accepted = ["image/png", "image/jpeg", "image/jpg", "image/gif", "image/webp"];
        if (!accepted.includes(file.type)) {
            setNotification({
                open: true,
                msg: "Only PNG, JPG, GIF, or WebP images are allowed.",
                type: "error",
            });
            return;
        }

        if (file.size > 5 * 1024 * 1024) {
            setNotification({
                open: true,
                msg: "Image must not exceed 5MB.",
                type: "error",
            });
            return;
        }

        try {
            const base64 = await Helpers.getBase64Arry(file);
            setImagePayload(base64);
            setImagePreview(base64);
            setRemoveImage(false);
            if (isEdit) {
                setSelectedRow((prevValues) => ({
                    ...prevValues,
                    image: base64,
                }));
            }
        } catch (err) {
            setNotification({
                open: true,
                msg: "Failed to read image file.",
                type: "error",
            });
        }
    };

    const handleSubmitNewServiceType = () => {
        let payload = {
            service_type: values?.service_type,
            sort_order: values?.sort_order,
            image: imagePayload || undefined,
        }
        dispatch(createServiceType(payload));
        setIsLoading(true);
    }

    const handleSubmitEditServiceType = () => {
        let payload = {
            service_type: (selectedRow?.service_descriptions?.length > 0 && selectedRow?.service_descriptions[0].name) || "",
            sort_order: selectedRow?.sort_order,
            status: selectedRow?.status,
            remove_image: removeImage ? 1 : 0,
        }
        if (imagePayload) {
            payload.image = imagePayload;
        }
        dispatch(updateServiceType({ id: selectedRow?.id, data: payload }));
        setIsLoading(true);
    }

    const resetFilter = () => {
        setPage("1");
        setSearch('');
        setFilterStatus(filterStatus === '' ? 'all' : '');
    }

    const handleSearch = (text) => {
        setSearch(text);
        setTimeout(() => {
            if (text === searchRef.current) {
                setPage("1");
                initData();
            }
        }, Helpers.searchInterval);
    }

    useEffect(() => {
        if (checkedAll && serviceTypeListing?.data) {
            const productListingIDs = serviceTypeListing.data.map((item) => item.id);
            setSelectedRow(productListingIDs);
        } else if (!checkedAll && selectedRow.length === serviceTypeListing?.data?.length) {
            // Only clear if all items were selected (meaning user clicked "uncheck all" header)
            setSelectedRow([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkedAll, serviceTypeListing?.data]);

    const handleCheckboxChange = (e) => {
        setCheckedAll(false)
        let temp = []
        if (selectedRow && selectedRow?.length > 0 && selectedRow.includes(parseInt(e))) {
            temp = selectedRow.filter((x) => x !== parseInt(e)).map((y) => y)
            setSelectedRow(temp)
        } else {
            setSelectedRow([...selectedRow, parseInt(e)])
        }
    }

    const handleDelete = () => {
        if (selectedRow?.length > 0) {
            setIsLoading(true);
            dispatch(bulkDeleteServiceType({ ids: selectedRow }))

        } else {
            setIsLoading(true);
            dispatch(deleteServiceType({ ID: selectedRow?.id }))
        }
    }

    const handleExport = () => {
        let filter = {
            status: filterStatus,
            search: keyword
        }
        Object.keys(filter).forEach(key => {
            if (!filter[key] || filter[key] === 'all') {
                delete filter[key];
            }
        });
        setIsLoading(true);
        dispatch(exportServiceType({
            sort: sort_by,
            sort_order: sort,
            filter: filter
        }));
    }

    const addServiceTypeModal = () => {
        return (
            <AppDialog
                titleIcon={'add'}
                title={'Add Service Type'}
                open={addModalOpen}
                close={() => { setAddModalOpen(false); resetImageState(); dispatch(resetServiceTypeAttachmentState()) }}
                positiveTitle={'Save'}
                positivePress={() => handleSubmitNewServiceType()}
                negativeTitle={'Cancel'}
                negativePress={() => { setAddModalOpen(false); setFormValues(""); resetImageState(); dispatch(resetServiceTypeAttachmentState()) }}
                width={'40%'}
            >
                <Grid container>
                    <Grid item sm={12}>
                        <CustomTextField
                            title={'Service Type'}
                            values={values?.service_type}
                            onChange={(e) => setFormValues((prevValues) => ({
                                ...prevValues,
                                service_type: e
                            }))}
                            placeholder="e.g. Warranty Upgrade"
                        />
                        {error && <FormHelperText sx={{ color: "red" }}>{error.service_type || ""}</FormHelperText>}
                    </Grid>
                    <Grid item sm={12} mt={2}>
                        <div className="setting-form-section-header mb-2">Artwork</div>
                        <div className="setting-desc mb-2">Default image for this service group. For unique artwork per option (e.g. X13 4Y upgrade), open the service and edit each type. PNG, JPG, GIF, or WebP. Max 5MB.</div>
                        {imagePreview && (
                            <div className="mb-2" style={{ border: '1px solid #EDEDED', borderRadius: 8, overflow: 'hidden', width: 120, height: 120 }}>
                                <img src={imagePreview} alt="Service artwork preview" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                            </div>
                        )}
                        <div className="d-flex flex-wrap align-items-center" style={{ gap: 8 }}>
                            <CustomButton
                                title="Choose image"
                                press={() => addImageInputRef.current?.click()}
                                backgroundColor="#101010"
                                textColor="#FFFFFF"
                                borderStyle="1px solid #101010"
                            />
                            {imagePreview && (
                                <CustomButton
                                    title="Remove"
                                    press={() => {
                                        setImagePreview('');
                                        setImagePayload(null);
                                        if (addImageInputRef.current) addImageInputRef.current.value = '';
                                    }}
                                    backgroundColor="white"
                                    textColor="#101010"
                                    borderStyle="1px solid #E3E8EE"
                                />
                            )}
                            <input
                                type="file"
                                ref={addImageInputRef}
                                style={{ display: 'none' }}
                                accept="image/png,image/jpeg,image/jpg,image/gif,image/webp"
                                onChange={(e) => handleChooseImage(e.target.files?.[0], false)}
                            />
                        </div>
                        {error && <FormHelperText sx={{ color: "red" }}>{error.image || ""}</FormHelperText>}
                    </Grid>
                    <Grid item sm={12} mt={2}>
                        <CustomTextField
                            title={'Sort order'}
                            values={values?.sort_order}
                            onChange={(e) => setFormValues((prevValues) => ({
                                ...prevValues,
                                sort_order: e
                            }))}
                            type={'phone'}
                            placeholder="0"
                        />
                        {error && <FormHelperText sx={{ color: "red" }}>{error.sort_order || ""}</FormHelperText>}
                    </Grid>
                </Grid>
            </AppDialog>
        )
    }

    const editServiceTypeModal = () => {
        return (
            <AppDialog
                titleIcon={'edit'}
                title={'Edit Service Type'}
                open={editModalOpen}
                close={() => { setEditModalOpen(false); resetImageState(); dispatch(resetServiceTypeAttachmentState()) }}
                positiveTitle={'Save Changes'}
                positivePress={() => handleSubmitEditServiceType()}
                negativeTitle={'Cancel'}
                negativePress={() => { setEditModalOpen(false); resetImageState(); dispatch(resetServiceTypeAttachmentState()) }}
                width={'40%'}
            >
                <Grid container>
                    <Grid item sm={12}>
                        <CustomTextField
                            title={'Service Type'}
                            values={selectedRow?.service_descriptions?.length > 0 && selectedRow?.service_descriptions[0].name}
                            onChange={(e) => {
                                let temp = selectedRow.service_descriptions;
                                if (temp?.length > 0) {
                                    temp[0].name = e;
                                    setSelectedRow((prevValues) => ({
                                        ...prevValues,
                                        service_descriptions: temp
                                    }))
                                }
                            }}
                            placeholder="e.g. Warranty Upgrade"
                        />
                        {error && <FormHelperText sx={{ color: "red" }}>{error.service_type || ""}</FormHelperText>}
                    </Grid>
                    <Grid item sm={12} mt={2}>
                        <div className="setting-form-section-header mb-2">Artwork</div>
                        <div className="setting-desc mb-2">Default image for this service group. For unique artwork per option (e.g. X13 4Y upgrade), open the service and edit each type. PNG, JPG, GIF, or WebP. Max 5MB.</div>
                        {imagePreview && !removeImage && (
                            <div className="mb-2" style={{ border: '1px solid #EDEDED', borderRadius: 8, overflow: 'hidden', width: 120, height: 120 }}>
                                <img src={imagePreview} alt="Service artwork preview" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                            </div>
                        )}
                        <div className="d-flex flex-wrap align-items-center" style={{ gap: 8 }}>
                            <CustomButton
                                title="Choose image"
                                press={() => editImageInputRef.current?.click()}
                                backgroundColor="#101010"
                                textColor="#FFFFFF"
                                borderStyle="1px solid #101010"
                            />
                            {(imagePreview || selectedRow?.service_descriptions?.[0]?.image) && (
                                <CustomButton
                                    title="Remove"
                                    press={() => {
                                        setImagePreview('');
                                        setImagePayload(null);
                                        setRemoveImage(true);
                                        if (editImageInputRef.current) editImageInputRef.current.value = '';
                                    }}
                                    backgroundColor="white"
                                    textColor="#101010"
                                    borderStyle="1px solid #E3E8EE"
                                />
                            )}
                            <input
                                type="file"
                                ref={editImageInputRef}
                                style={{ display: 'none' }}
                                accept="image/png,image/jpeg,image/jpg,image/gif,image/webp"
                                onChange={(e) => handleChooseImage(e.target.files?.[0], true)}
                            />
                        </div>
                        {error && <FormHelperText sx={{ color: "red" }}>{error.image || ""}</FormHelperText>}
                    </Grid>
                    <Grid item sm={12} mt={2}>
                        <CustomTextField
                            title={'Sort order'}
                            values={selectedRow?.sort_order?.toString()}
                            onChange={(e) => setSelectedRow((prevValues) => ({
                                ...prevValues,
                                sort_order: e
                            }))}
                            type={'number'}
                            placeholder="0"
                        />
                        {error && <FormHelperText sx={{ color: "red" }}>{error.sort_order || ""}</FormHelperText>}
                    </Grid>
                    <Grid item sm={12} mt={2}>
                        <RadioButtonGroup
                            title={'Status'}
                            value={selectedRow?.status}
                            data={data}
                            setValue={(e) => setSelectedRow((prevValues) => ({
                                ...prevValues,
                                status: e,
                            }))}
                            required="true"
                            name="status"
                        />
                        {error && <FormHelperText sx={{ color: "red" }}>{error.status || ""}</FormHelperText>}
                    </Grid>
                </Grid>
            </AppDialog>
        )
    }

    const customToolsBar = () => {
        return (
            <Grid container rowSpacing={2} mb={0} paddingBlock={1}>
                <Grid container item xs={12} sm={8} md={8} lg={8} className="d-flex align-items-center" spacing={1}>
                    <Grid item lg={3} md={3} sm={4} xs={12}>
                        <SearchBar
                            value={keyword}
                            setValue={(e) => handleSearch(e)}
                        />
                    </Grid>
                    <Grid item lg={3} md={3} sm={4} xs={12}>
                        <CustomSelect2 values={filterStatus || "all"} onChange={(e) => { setPage("1"); setFilterStatus(e || '') }} data={Helpers.status} placeholder={'All Statuses'} />
                    </Grid>
                    <Grid item lg={6} md={6} sm={4} xs={12}>
                        <CustomButton
                            title={'Clear'}
                            press={() => resetFilter()}
                            height={32}
                            backgroundColor={'transparent'}
                            textColor={'#7BB9FA'}
                        />
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={4} md={4} lg={4} sx={{ gap: 1, display: 'flex', justifyContent: { lg: 'end', sm: 'end' } }} alignItems={'center'}>
                    {exportable && <CustomButton
                        title={<><i className="ri-download-2-line" style={{ marginRight: 5 }} />Export</>}
                        press={() => handleExport()}
                        height={32}
                        borderRadius={15}
                        borderStyle={"1px solid #babcbe"}
                    />}
                    {deletable && selectedRow && selectedRow?.length > 0 && <CustomButton
                        title={<><i className="ri-delete-bin-line" style={{ marginRight: 5 }} />Delete</>}
                        press={() => setDeleteOpen(true)}
                        height={32}
                        borderRadius={15}
                        textColor={"white"}
                        backgroundColor={"#44d62c"}
                        borderStyle={"1px solid #44d62c"}
                    />}
                </Grid>
            </Grid>
        )
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <LoadingDialog open={loading || !serviceTypeListing?.data} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    <Breadcrumb
                        backRoute={'/settings'}
                        breadcrumbItems={[{ title: "Settings", link: "/settings" },
                        { title: title, link: "#" },
                        ]}
                    >
                        {creatable && <CustomButton
                            title={<><i className="ri-add-line" style={{ marginRight: '5px' }} /> Add Service Type</>}
                            press={() => { resetImageState(); setFormValues({ category: '' }); setAddModalOpen(true); }}
                            height={40}
                            backgroundColor={'#101010'}
                            textColor={'white'}
                        />}
                    </Breadcrumb>
                    {customToolsBar()}
                    <Table
                        header={header}
                        data={serviceTypeListing?.data || []}
                        pageSize={length}
                        totalPage={serviceTypeListing?.last_page || 1}
                        customToolsBar={true}
                        sort={sort}
                        setSorted={setSorted}
                        sort_by={sort_by}
                        setSortBy={setSortBy}
                        setCheckedAll={setCheckedAll}
                        checkedAll={checkedAll}
                    />

                    <TablePageControl
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={serviceTypeListing?.last_page || 1}
                    />
                    {addServiceTypeModal()}
                    {editServiceTypeModal()}
                    <DeleteModal
                        open={deleteOpen}
                        close={() => {  setDeleteOpen(false); setSelectedRow([]); setCheckedAll(false); }}
                        submit={() => handleDelete()}
                        module={'service type'}
                    />
                </Container>
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ ServiceType, Login }) {
    return {
        serviceTypeListing: ServiceType.serviceTypeListing.data,
        exportServiceTypeDocument: ServiceType.exportServiceType,
        addServiceType: ServiceType.addServiceType,
        delServiceTypeArry: ServiceType.deleteServiceType,
        bulkDeleteServiceTypeArr: ServiceType.bulkDeleteServiceType,
        editServiceType: ServiceType.updateServiceType,
        formError: ServiceType.error,
        userPermission: Login.permissionArry,

    };
}

export default connect(mapStateToProps)(ProductServiceSetting);